import React from 'react';
import Manage from './Manage'
import {request} from '../helpers/request'
import {t} from '../helpers/translate.js'
let config = require('config');
import Immutable from 'immutable'
import {Panel, ListGroup, ListGroupItem, Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap'
import Icon from 'react-fa'

class Claim extends Manage {

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.showLoading();
    $.when(
      request(`${config.default.api}/claim/${this.props.location.state.claim_id}`, 'GET', null, this.loadClaimData.bind(this))
    )
    .done(this.parseForm.bind(this));
    this.showLoading();
  }

  loadClaimData(responseData, statusCode) {
    if (statusCode == 200) {
      let claimData = Immutable.fromJS(responseData);
      this.setState({
        claimLoaded: true,
        data: this.state.data.set('claim', claimData),
        backup: this.state.backup.set('claim', claimData),
      })
    } else {
      this.showModal( t('Error'), t('Unable to get claim data'));
    }
  }

  isDataReady() {
    return this.state.claimLoaded && this.state.parsedForm;
  }

  getFormConfig(){
    return config.default.claim.ingle.field_groups
  }

  renderReloadButton(){
    return null
  }

  renderModifyButton(){
    return null
  }

  getPageTitle(){
    return t('View Claim')
  }

  getButtons() {
    return <ButtonToolbar>
      <button className="btn button-secondary" onClick={() => {window.history.back()}}>
        <Icon name="chevron-left"/> {t('Return to Search Results')}
      </button>
    </ButtonToolbar>
  }

  getAttachments() {
    return this.state.data.getIn(['claim', 'documents']).toJS();
  }

}

export default Claim;



// WEBPACK FOOTER //
// ./src/components/Claim.js